import React from 'react';

const HeaderProfileIcon = ({ onClick, className = '', size = 'desktop' }) => {
    const isMobile = size === 'mobile';
    const buttonSize = isMobile ? '35px' : '43px';
    const padding = isMobile ? '15px' : '20px';
    const svgSize = isMobile ? '12px' : '14px';
    const svgHeight = isMobile ? '16px' : '20px';

    return (
        <button
            onClick={onClick}
            className={`flex items-center justify-center cursor-pointer transition-all duration-200 hover:scale-105 ${className}`}
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                padding: padding,
                gap: '8px',
                width: buttonSize,
                height: buttonSize,
                background: 'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(40, 227, 218, 0.5) 0%, rgba(40, 227, 218, 0) 100%), rgba(40, 227, 218, 0.25)',
                boxShadow: '0px 8px 32px rgba(255, 255, 255, 0.08)',
                backdropFilter: 'blur(1px)',
                borderRadius: '100px',
                flex: 'none',
                order: 0,
                flexGrow: 0
            }}
        >
                            <svg
                    width={svgSize}
                    height={svgHeight}
                    viewBox="0 0 17 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                        width: svgSize,
                        height: svgHeight,
                        flex: 'none',
                        order: 0,
                        flexGrow: 0
                    }}
                >
                <path d="M15.5001 4.5L8.50006 1.5L1.50006 4.5L5.00006 6V8M15.5001 4.5L12.0001 6V8M15.5001 4.5V8.5M5.00006 8C5.00006 8 6.16706 7.5 8.50006 7.5C10.8331 7.5 12.0001 8 12.0001 8M5.00006 8V9C5.00006 9.45963 5.09059 9.91475 5.26648 10.3394C5.44237 10.764 5.70018 11.1499 6.02519 11.4749C6.35019 11.7999 6.73603 12.0577 7.16067 12.2336C7.58531 12.4095 8.04043 12.5 8.50006 12.5C8.95969 12.5 9.41481 12.4095 9.83945 12.2336C10.2641 12.0577 10.6499 11.7999 10.9749 11.4749C11.2999 11.1499 11.5577 10.764 11.7336 10.3394C11.9095 9.91475 12.0001 9.45963 12.0001 9V8M4.28306 16.203C3.18306 16.888 0.297061 18.285 2.05406 20.034C2.91306 20.89 3.87006 21.5 5.07106 21.5H11.9291C13.1311 21.5 14.0871 20.889 14.9461 20.034C16.7031 18.285 13.8181 16.888 12.7171 16.204C11.4511 15.4174 9.99046 15.0005 8.50006 15.0005C7.00966 15.0005 5.54897 15.4174 4.28306 16.204" stroke="#D5D2D2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </button>
    );
};

export default HeaderProfileIcon;
